import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createEspacioCurricularPciSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
  carga_horaria: yup
    .number()
    .typeError(DEFAULT_MESSAGES.REQUIRED)
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(1, "Debe ser al menos 1"),
  detalle_modificacion: yup.string().max(500, "Máximo 500 caracteres"),
  anio: yup
    .number()
    .typeError(DEFAULT_MESSAGES.REQUIRED)
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(1, "Debe ser al menos 1")
    .max(12, "Debe ser menor o igual a 12"),
  area_id: yup.mixed().required(DEFAULT_MESSAGES.REQUIRED),
  tipo_espacio_id: yup.mixed().required(DEFAULT_MESSAGES.REQUIRED),
});
